import { SagaIterator } from 'redux-saga';
import { call, put, select, takeEvery } from 'redux-saga/effects';
import { Messages } from '../../../../codegen/Localize';
import { ISubscriptionInfo } from '../../../../ts/models/ISubscriptionInfo';
import { Set } from '../../../../ts/models/Set';
import { ChangeScheduleAction } from '../../../../ts/services/ChangeScheduleAction';
import { ChangeSubscriptionDataConditionAction } from '../../../../ts/services/ChangeSubscriptionDataConditionAction';
import { ChangeSubscriptionsFormatAction } from '../../../../ts/services/ChangeSubscriptionsFormatAction';
import { ChangeSubscriptionSubjectAction } from '../../../../ts/services/ChangeSubscriptionSubjectAction';
import { DeleteSubscriptionsAction } from '../../../../ts/services/DeleteSubscriptionsAction';
import { ResumeSubscriptionAction } from '../../../../ts/services/ResumeSubscriptionAction';
import {
  ChangeSubscriptionDataCondition,
  ChangeSubscriptionsFormat,
  ChangeSubscriptionsSchedule,
  ChangeSubscriptionSubject,
  DeleteSubscriptions,
  ResumeSubscription
} from '../../../actions/AppActionTypes';
import { requestFailed } from '../../../actions/RequestFailedAction';
import { requestSpaceContents } from '../../../actions/spaces/RequestSpaceContentsActions';
import {
  ChangeSubscriptionDataConditionAction as ChangeSubscriptionDataConditionReduxAction,
  ChangeSubscriptionsFormatAction as ChangeSubscriptionsFormatReduxAction,
  ChangeSubscriptionsScheduleAction as ChangeSubscriptionsScheduleReduxAction,
  ChangeSubscriptionSubjectAction as ChangeSubscriptionSubjectReduxAction,
  DeleteSubscriptionsAction as DeleteSubscriptionsReduxAction,
  ResumeSubscriptionAction as ResumeSubscriptionReduxAction
} from '../../../actions/spaces/SubscriptionsActions';
import { ServiceLocator } from '../../../ServiceLocator';

export function* handleChangeSubscriptionSubject(action: ChangeSubscriptionSubjectReduxAction) {
  try {
    yield call(changeSubscriptionSubject, action.subscription);

    yield call(refreshAfterSubscriptionActionSucceeded);
  } catch(e) {
    yield put(requestFailed(e, Messages.favoritesError()));
  }
}

export function changeSubscriptionSubject(subscription: ISubscriptionInfo) {
  const context = ServiceLocator.getAngularActionContext();
  return ServiceLocator.get<ChangeSubscriptionSubjectAction>('ChangeSubscriptionSubjectAction')
      .changeSubject(subscription, context);
}

export function* handleChangeSubscriptionsSchedule(action: ChangeSubscriptionsScheduleReduxAction) {
  try {
    yield call(changeSubscriptionsSchedule, action.subscriptions);

    yield call(refreshAfterSubscriptionActionSucceeded);
  } catch(e) {
    yield put(requestFailed(e, Messages.favoritesError()));
  }
}

export function changeSubscriptionsSchedule(subscriptions: ISubscriptionInfo[]) {
  const context = ServiceLocator.getAngularActionContext();
  return ServiceLocator.get<ChangeScheduleAction>('ChangeScheduleAction')
      .forSubscriptions(Set.fromIdItemArray(subscriptions), context);
}

export function* handleChangeSubscriptionDataCondition(action: ChangeSubscriptionDataConditionReduxAction) {
  try {
    yield call(changeSubscriptionDataCondition, action.subscription);

    yield call(refreshAfterSubscriptionActionSucceeded);
  } catch(e) {
    yield put(requestFailed(e, Messages.favoritesError()));
  }
}

export function changeSubscriptionDataCondition(subscription: ISubscriptionInfo) {
  const context = ServiceLocator.getAngularActionContext();
  return ServiceLocator.get<ChangeSubscriptionDataConditionAction>('ChangeSubscriptionDataConditionAction')
      .changeDataCondition(subscription, context);
}

export function* handleDeleteSubscriptions(action: DeleteSubscriptionsReduxAction) {
  try {
    yield call(deleteSubscriptions, action.subscriptions);

    yield call(refreshAfterSubscriptionActionSucceeded);
  } catch(e) {
    yield put(requestFailed(e, Messages.favoritesError()));
  }
}

export function deleteSubscriptions(subscriptions: ISubscriptionInfo[]) {
  const context = ServiceLocator.getAngularActionContext();
  return ServiceLocator.get<DeleteSubscriptionsAction>('DeleteSubscriptionsAction')
      .deleteSubscriptions(Set.fromIdItemArray(subscriptions), context);
}

export function* handleResumeSubscription(action: ResumeSubscriptionReduxAction) {
  try {
    yield call(resumeSubscription, action.subscription);

    yield call(refreshAfterSubscriptionActionSucceeded);
  } catch(e) {
    yield put(requestFailed(e, Messages.favoritesError()));
  }
}

export function resumeSubscription(subscription: ISubscriptionInfo) {
  return ServiceLocator.get<ResumeSubscriptionAction>('ResumeSubscriptionAction')
      .resumeSubscription(subscription);
}

export function* handleChangeSubscriptionsFormat(action: ChangeSubscriptionsFormatReduxAction) {
  try {
    yield call(changeSubscriptionsFormat, action.subscriptions);

    yield call(refreshAfterSubscriptionActionSucceeded);
  } catch(e) {
    yield put(requestFailed(e, Messages.favoritesError()));
  }
}

export function changeSubscriptionsFormat(subscriptions: ISubscriptionInfo[]) {
  const context = ServiceLocator.getAngularActionContext();
  return ServiceLocator.get<ChangeSubscriptionsFormatAction>('ChangeSubscriptionsFormatAction')
      .changeFormat(Set.fromIdItemArray(subscriptions), context);
}

export function* refreshAfterSubscriptionActionSucceeded() {
  yield put(requestSpaceContents());
}

export function* rootSubscriptionSagas(): SagaIterator {
  yield takeEvery(ChangeSubscriptionSubject, handleChangeSubscriptionSubject);
  yield takeEvery(ChangeSubscriptionsSchedule, handleChangeSubscriptionsSchedule);
  yield takeEvery(ChangeSubscriptionDataCondition, handleChangeSubscriptionDataCondition);
  yield takeEvery(DeleteSubscriptions, handleDeleteSubscriptions);
  yield takeEvery(ResumeSubscription, handleResumeSubscription);
  yield takeEvery(ChangeSubscriptionsFormat, handleChangeSubscriptionsFormat);
}
